export default {
	inProcessDev: `Səhifə hazırlanır! <br/> Tezliklə bütün funksiyalarından istifadə edə biləcəksiniz. <br/> <strong> Anladığınız üçün təşəkkürlər </strong>`,
}